import { render, staticRenderFns } from "./CompletitionLayout.vue?vue&type=template&id=545faf30&"
import script from "./CompletitionLayout.vue?vue&type=script&lang=ts&"
export * from "./CompletitionLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports